.SelectList {
  &_WithSmallerIndent {
    overflow-y: unset;
  }
}
